export default __webpack_public_path__ + "static/FoundersGrotesk-Bold-22e9ef3d3c668ac826f7d606ec54e00e.otf";